import React, {Component} from "react";

class HomePartners extends Component {

    componentWillMount() {
        const maxToShow = this.props.max
        let partnersList = this.props.proxy.querySelector(".home-partners-component--list"), i, j
        if (partnersList.children.length) {
            for (i = 0; i < partnersList.children.length; i++) {
                partnersList.appendChild(partnersList.children[Math.random() * i | 0])
            }
            let childsToRemove = partnersList.children.length >= maxToShow ? partnersList.children.length - maxToShow : 0
            if (childsToRemove >= 1) {
                for (j = 0; j < childsToRemove; j++) {
                    partnersList.removeChild(partnersList.children[j])
                }
            }
        }
    }

    render() {
        return <div></div>
    }
}

export default (HomePartners)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/home-partners/HomePartners.js